<template lang="jade">
  div.Input(":tooltip"="fdata.tip || false"
            v-bind:class="{'Input--filled': formInput, 'Input--invalid': error, 'Input--valid': complete }"
            ":skin"="skins.inputs")
    textarea.Input__field(class="Input__field--textarea"
                          ":disabled"="!fdata.editable"
                          ":class"="fdata.class"
                          ":placeholder"="fdata.placeholder"
                          v-model="formInput"
                          @keypress.enter="validate"
                          @blur="validate"
                          ":required"="required")
    label.Input__label
      span.Input__label-content
        i.fa.fa-pencil(style="margin-right: 10px")
        {{ fdata.label }}
    div.Error(v-if="errors" class="animated" transition="fade") 
      p.Error__msg {{ errors }}        
</template>

<script>
  import { textEditor } from './_shared/directives'
  import { addNotification, removeNotification } from 'src/vuex/actions'
  import { skins, config } from 'src/vuex/getters'
  // import inputs from '../_shared/traits'

  export default {
    // mixins: [inputs],
    data () {
      return {
        formInput: '',
        editorUID: this.createUID('editor'),
        error: false,
        errors: null
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce (val) {
          if (val.editable === false) {
            val.field = false
          }
          // Convert the array into a string seperated by a \n
          if (Array.isArray(val.value) && val.value.length > 1) {
            val.value = val.value.reduce((a, b) => {
              return a + '\n' + b
            })
          }
          return val
        }
      },
      validation: {
        type: Boolean,
        default: true
      }
    },
    vuex: {
      actions: {
        addNotification,
        removeNotification
      },
      getters: {
        skins,
        config
      }
    },
    directives: {
      textEditor
    },
    computed: {
      isHtml () {
        return this.fdata.format === 'html'
      },
      required () {
        return _.some(this.fdata.validation, ['rule', 'required'])
      }
    },
    methods: {
      validate () {
        if (!this.validation) return this.dispatch()
        let validated = this.computedValidate(this.fdata,
                                              this.formInput)
        if (this.config.inlineErrors) {
          this.$set('errors', validated)
        }
        this.fieldState(validated)
        this.notice('error', validated)
      },

      notice (type, valid) {
        _.isNil(valid) || _.isEmpty(valid)
          ? this.removeNotification(this.fdata.field)
          : this.addNotification({
            type: type,
            msg: valid,
            id: this.fdata.field,
            show: !this.config.inlineErrors
          })

        this.dispatch()
      },

      fieldState (valid) {
        if (this.attempts < 1) return false
        _.isNil(valid) ? this.setFieldComplete() : this.setFieldError()
      },

      setFieldComplete () {
        this.$set('complete', true)
        this.$set('error', false)
      },

      setFieldError () {
        this.$set('error', true)
        this.$set('complete', false)
      },

      dispatch () {
        if (this.fdata.field && this.fdata.editable) {
          this.$dispatch('fdata::input', {
            [this.fdata.field]: this.formInput.split('\n')
          })
        }
      }
    },
    ready () {
      let val = this.fdata.value
      this.formInput = _.isArray(val) ? val.join('\n') : val
      if (this.validation) this.validate()
    }
  }
</script>



// WEBPACK FOOTER //
// textarea.vue?528788c7